(function (window, document) {

    var init = false
    function initSearch() {
        $("#searchButton").on("click", function (e) {
            $("#search").css('left', (e.currentTarget.getBoundingClientRect().left - 250) + 'px' )
            if ($("#search").css('display') === 'none') {
                if (!init) {
                    $.getScript("https://cse.google.com/cse.js?cx=016824523753071399906:g1sfqfw5wik");
                    init = true
                }
                $("#search").css('display', 'inherit')
            } else {
                $("#search").css('display', 'none')
            }

        })
    }

    function move()  {
        if (
            // only do it when window is wider than height (desktop)
            (window.innerWidth / window.innerHeight) > 0.75 &&
            document.getElementsByClassName("kg-image").length > 0 &&
            document.getElementsByClassName("post-full-custom-excerpt").length === 0) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".kg-image").first().offset().top - 80
            }, 1);
        }
    }


    document.addEventListener('DOMContentLoaded', initSearch);
    document.addEventListener('DOMContentLoaded', move);

})(window, document);
